import { useCallbackRef } from '../../react-use-callback-ref/dist/index.module.js';
import * as React from 'react';

function useEscapeKeydown(n){const o=useCallbackRef(n);React.useEffect((()=>{const e=e=>{"Escape"===e.key&&o(e);};return document.addEventListener("keydown",e),()=>document.removeEventListener("keydown",e)}),[o]);}

export { useEscapeKeydown };
